import { CustomersListContainer } from './list/container';
import { CustomerViewContainer } from './view/container';

export const CustomersListRoute = CustomersListContainer;
export const CustomerViewRoute = CustomerViewContainer;
